var _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMissionSeven(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 66,
    viewBox: "0 0 60 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.386,
    cy: 25.0457,
    r: 23.2411,
    stroke: "white",
    strokeWidth: 2.85131
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7649,
    cy: 48.8606,
    r: 14.8568,
    stroke: "white",
    strokeWidth: 2.85131
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.3443,
    cy: 56.5177,
    r: 4.59087,
    stroke: "white",
    strokeWidth: 2.24031
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4333 9.82385L41.4834 9.8809L41.5445 9.9261C41.8605 10.1602 42.3852 10.4813 42.9745 10.7147C43.5427 10.9398 44.2921 11.1324 44.9971 10.9562C45.2449 10.8942 45.4932 10.7756 45.6863 10.5673C45.8864 10.3514 45.9825 10.0869 45.9948 9.82209C46.0174 9.33517 45.7629 8.88682 45.4852 8.55448C44.9027 7.85747 43.8474 7.21659 42.5689 7.00927C42.084 6.93063 41.603 6.92247 41.2187 7.11468C41.0054 7.22137 40.826 7.38858 40.7155 7.61431C40.6096 7.8309 40.5918 8.05044 40.6067 8.23158C40.6349 8.57372 40.789 8.89675 40.9298 9.13582C41.0799 9.39066 41.264 9.63117 41.4333 9.82385Z",
    stroke: "white",
    strokeWidth: 1.42565
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissionSeven);
export default __webpack_public_path__ + "static/media/iconMissionSeven.5e5827a854c58ee39e3293eb9d35b647.svg";
export { ForwardRef as ReactComponent };